import { format, parseISO } from "date-fns";

export function buildRenewalSettingsChangelogLines(args: {
  tierChanged?: { fromName: string; toName: string };
  dateChanged?: { fromDate: string; toDate: string; isFixedDate: boolean };
}): string[] {
  const lines: string[] = [];
  if (args.tierChanged) {
    lines.push(
      `Membership option changed from ${args.tierChanged.fromName} to ${args.tierChanged.toName}.`,
    );
  }
  if (args.dateChanged) {
    const parsed = parseISO(args.dateChanged.toDate);
    if (args.dateChanged.isFixedDate) {
      lines.push(
        `Your renewal date is now on ${format(parsed, "MMMM d")} of every year.`,
      );
    } else {
      lines.push(`Your renewal date is now ${format(parsed, "MMMM d, yyyy")}.`);
    }
  }
  return lines;
}
